import { create } from 'zustand';
import { persist } from 'zustand/middleware';

//* UI 세터가 없는 개발용 스토어 — localStorage `wello-debug`를 직접 편집해 지정한다.
interface DebugState {
  kbEventDateIndex: number | null;
}

export const useDebugStore = create<DebugState>()(
  persist((): DebugState => ({ kbEventDateIndex: null }), {
    name: 'wello-debug',
  }),
);
